import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=32cf1b20"
import script from "./VerifyIdentity.vue?vue&type=script&lang=js"
export * from "./VerifyIdentity.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./VerifyIdentity.vue?vue&type=style&index=2&id=32cf1b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports